
import StatusErrorPage from '../StatusPage/ErrorPage/StatusErrorPage';

const ErrorPage = () => {
    return <StatusErrorPage />;
};

export default ErrorPage;
